var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9042507_facebook_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6426 2H14.6426C13.3165 2 12.0447 2.52678 11.1071 3.46447C10.1694 4.40215 9.64258 5.67392 9.64258 7V10H6.64258V14H9.64258V22H13.6426V14H16.6426L17.6426 10H13.6426V7C13.6426 6.73478 13.748 6.48043 13.9355 6.29289C14.123 6.10536 14.3774 6 14.6426 6H17.6426V2Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSecond);
export default __webpack_public_path__ + "static/media/facebook_second.b20c249d7b779b9325d4062846e682e1.svg";
export { ForwardRef as ReactComponent };